export const ExpandIcon = ({
	color = 'var(--mono400)',
	width = '24',
	height = '24',
	...props
}): JSX.Element => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M7.6875 16.3438C7.6875 16.7266 7.38672 17 7.03125 17C6.64844 17 6.375 16.7266 6.375 16.3438V7.15625C6.375 6.80078 6.64844 6.5 7.03125 6.5C7.38672 6.5 7.6875 6.80078 7.6875 7.15625V16.3438ZM13.7852 8.74219C13.5391 8.49609 13.5117 8.08594 13.7578 7.8125C14.0039 7.53906 14.4414 7.53906 14.6875 7.78516L18.4062 11.2852C18.6797 11.5312 18.6797 11.9961 18.4062 12.2422L14.6875 15.7422C14.4414 15.9883 14.0039 15.9883 13.7578 15.7148C13.6484 15.5781 13.5938 15.4141 13.5938 15.25C13.5938 15.0859 13.6484 14.9219 13.7852 14.7852L16.3008 12.4062H9.65625C9.27344 12.4062 9 12.1328 9 11.75C9 11.3945 9.27344 11.0938 9.65625 11.0938H16.3008L13.7852 8.74219Z"
			fill={color}
		/>
	</svg>
)
